import { pages } from './pages'
import { main } from '@/lang/de/main.ts'
import { errors } from '@/lang/de/errors.ts'

export default {
  main,
  pages,
  errors,
}
